import HTTP from "@/_helpers/http";
import { MAMWALLET__API } from "@/_helpers/urls";
import { MAMWALLET__MUTATIONS } from "../mutation-types";
import { MAMWALLET__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  trades: [],
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  },
  summaries: {
    totalProfit: 0,
    totalVolume: 0,
    totalEquity: 0
  },
  isLoading: false,
  transferLoading: false,
};

const getters = {};

const mutations = {
  [MAMWALLET__MUTATIONS.MANAGERSCOMMISSIONHISTORY](state, data) {

    // Update trades
    state.trades = data?.data?.trades || [];

    // Update pagination
    state.pagination = data?.data?.pagination || {
      total: 0,
      perPage: 10,
      currentPage: 1,
      lastPage: 1
    };

    // Update summaries
    state.summaries = data?.data?.summaries || {
      totalProfit: 0,
      totalVolume: 0,
      totalEquity: 0
    };

    state.lastUpdate = new Date().toISOString();
  },

  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
  SET_TRANSFER_LOADING(state, loading) {
    state.transferLoading = loading;
  },
};

const actions = {
  async [MAMWALLET__ACTIONS.MANAGERSCOMMISSIONHISTORY]({ commit }, parameter) {
    commit("SET_LOADING", true);

    try {
      const {
        page = 1,
        limit = 10,
        trading_account_type_id,
        search = "",
        duration,
      } = parameter || {};

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trading_account_type_id && { trading_account_type_id }),
        ...(duration && { duration }),
        ...(search && { search }),
      }).toString();

      const response = await HTTP().get(
        `${MAMWALLET__API.MANAGERSCOMMISSIONHISTORY}${
          queryParams ? `?${queryParams}` : ""
        }`
      );

      commit(MAMWALLET__MUTATIONS.MANAGERSCOMMISSIONHISTORY, response.data);
    } catch (error) {
      console.error("Error fetching manager commission history:", error);
      // you can also trigger a global toast here if you want
      // toast.error("Failed to fetch manager commission history");
    } finally {
      // ✅ always reset loading flag
      commit("SET_LOADING", false);
    }
  },
  async [MAMWALLET__ACTIONS.CREATEMAMWALLETWITHDRAW]({ commit }, data) {
    try {
      commit("SET_TRANSFER_LOADING", true);
      const response = await HTTP().post(
        MAMWALLET__API.CREATEMAMWALLETWITHDRAW,
        data
      );

      toast.success(response.data.message || "Withdraw completed successfully");
      return response.data;
    } catch (error) {
      console.error("CREATEMAMWALLETWITHDRAW error:", error);
      toast.error(
        error?.response?.data?.message || "Failed to complete withdraw"
      );
      throw error;
    } finally {
      commit("SET_TRANSFER_LOADING", false);
    }
  },
  async [MAMWALLET__ACTIONS.CREATEMAMWALLETINTX]({ commit }, data) {
    try {
      commit("SET_TRANSFER_LOADING", true);
      const response = await HTTP().post(MAMWALLET__API.CREATEMAMWALLETINTX, data);

      toast.success(
        response.data.message || "Internal transfer completed successfully"
      );
      return response.data;
    } catch (error) {
      console.error("CREATEMAMWALLETINTX error:", error);
      toast.error(
        error?.response?.data?.message || "Failed to complete internal transfer"
      );
      throw error;
    } finally {
      commit("SET_TRANSFER_LOADING", false);
    }
  },
};


export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions
};
